import * as utils from './utils';
import * as themeObject from './config/theme';
import * as config from './config';
import * as effects from './effects';
import * as clients from './clients';
import * as components from './components';
import * as componentsV2 from './componentsV2';
import * as constants from './constants';
import * as hocs from './hocs';
import * as permissions from './permissions';
import * as styles from './styles';
import * as icons from './icons';
import * as testing from './testing';
import * as types from './types';

// TODO: Config loader to properly load url(path) converting them to base64 images
import '~/styles/mapbox.global.css';
import '~/styles/generatedThemesVariables.global.css';

// NOTE: maintain backward compatibility.
// TODO: to be removed in 0.77
const theme = {
  ...config,
  theme: themeObject,
  ...themeObject,
};

export {
  clients,
  components,
  componentsV2,
  config,
  constants,
  effects,
  hocs,
  icons,
  permissions,
  styles,
  theme,
  utils,
  testing,
  types,
};
